module.exports = __webpack_public_path__ + "img/logo-hcd.344c5c206a00af80e4ad485132d967d8.png";